import { Text } from '@chakra-ui/react'
import { Encounter, EncounterType, WithId } from '@hb/shared'
import { useMemo } from 'react'

export interface EncounterHeaderAddonProps {
  encounters: WithId<Encounter>[]
}

const AntepartumHeaderAddon: React.FC<EncounterHeaderAddonProps> = ({ encounters }) => {
  const weightGain = useMemo(() => {
    if (encounters.length < 2) return null
    const firstWeight = encounters[encounters.length - 1]?.data?.vital?.weight
    const lastWeight = encounters[0]?.data?.vital?.weight
    if (firstWeight == null || lastWeight == null) return null
    return lastWeight - firstWeight
  }, [encounters])

  if (weightGain == null) return null
  return (
    <Text ml={4} fontSize="sm" color="gray.600">
      Weight gain:{' '}
      <Text as="span" fontWeight={600} color={weightGain >= 0 ? 'green.600' : 'red.500'}>
        {weightGain >= 0 ? '+' : ''}
        {weightGain.toFixed(1)} lbs
      </Text>
    </Text>
  )
}

export const encounterHeaderAddonRecord: Record<
  EncounterType,
  React.FC<EncounterHeaderAddonProps> | null
> = {
  [EncounterType.ANTEPARTUM]: AntepartumHeaderAddon,
  [EncounterType.PHYSICAL]: null,
  [EncounterType.ENCOUNTER]: null,
  [EncounterType.WELL_WOMAN]: null,
  [EncounterType.PRE_CONCEPTION]: null,
  [EncounterType.POSTPARTUM]: null,
  [EncounterType.BIRTHING_CENTER_ADMISSION]: null,
  [EncounterType.ULTRASOUND]: null,
}
